module.exports = __webpack_public_path__ + "img/inbox-announcement.51ad4ea0.svg";